import * as React from "react";
import cx from "classnames";
import style from "./Integrate.css";

import Icon1 from "./icons/icon_1.svg";
import Icon2 from "./icons/icon_2.svg";
import Icon3 from "./icons/icon_3.svg";
import Icon4 from "./icons/icon_4.svg";
import People from "./icons/People.svg";
import History from "./icons/History.svg";
// import IconFunction from "./icon_function.svg";

import substrate from "_images/shape.svg";
import shape from "_images/shape1.svg";
import hexahedron from "_images/hexahedron.svg";
import { ShapeGrey, ShapeBlue } from "components/Shape";
import { WordScroller } from "../../../WordScroller";

export const Integrate = () => (
  <section className={style.root}>
    <ShapeGrey className={style.shape1} animate="rotation slower" />
    <ShapeGrey className={style.shape2} animate="rotation fast" />
    <ShapeGrey className={style.shape3} animate="rotation slower" />
    <ShapeBlue
      className={style.shape4}
      animate="wow rotationIn fast"
      data-wow-offset="300"
    />
    <ShapeBlue
      className={style.shape5}
      animate="wow rotationIn fast"
      data-wow-offset="300"
    />

    <div className={cx(style.bg, style.bgTop)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 1920 510"
      >
        <path
          fill="#130F40"
          d="M1270 3.6c-27.2 1.9-232.2 15.6-455.5 30.4-223.3 14.8-410.9 27.5-417 28-64.9 6.4-126.1 28.1-182.4 64.7-48.4 31.5-90.5 74.5-121.2 123.6-10.8 17.3-14.6 24.8-58.9 117.6L0 441.4V515h1920v-10.8l-108.3-159.9c-59.5-87.9-111.8-164.5-116.1-170.2-47.9-63.2-114.3-113.7-187.6-142.6C1453.6 10.1 1397.6-.3 1338.2.1c-10.3.1-41 1.7-68.2 3.5z"
        />
      </svg>
    </div>

    <div className={cx(style.bg, style.bgBottom)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 1920 510"
      >
        <path
          fill="#130F40"
          d="M0 8.6v8.6l8.2 12.2C12.7 36 20 46.9 24.5 53.5c8.3 12.2 19.2 28.3 41.7 61.5 20.2 29.8 115 169.8 128.6 190 21.9 32.2 33.6 47 55.4 69.5 20.8 21.6 43.2 40.4 68.8 57.7 19.9 13.5 31 19.9 52.8 30.6 50.4 24.8 103.1 39.3 160.7 44.2 33.7 2.8 29.2 3.1 518.6-29.5 252.1-16.8 462.7-31 467.9-31.6 77.5-8.5 151.9-40.4 215-92.2 13.4-11 44.5-42.9 56.4-57.7 12.1-15.2 26.5-36.5 35.1-51.8 5.7-10.3 8.6-16.3 63.9-131.8l30.6-64.2V0H0v8.6z"
        />
      </svg>
    </div>

    <div className={cx(style.content)}>
      <div className="container">
        <h2 className={cx(style.header, "wow", "fadeInUp")} data-wow-offset="0">
          Domains of Expertise
        </h2>
        <ul className={style.list}>
          <li className={cx(style.item, "wow", "fadeInLeft")}>
            <div className={style.itemIcon}>
              <img src={Icon1} alt="Decision Theory" />
            </div>
            <div className={style.itemContent}>
              <header className={style.itemHeader}>Market Design</header>
              <p className={style.itemDesc}>
              Applied economics focused on the explicit design and structuring of markets to optimize specific objectives such as fairness in resource allocation, efficiency of price discovery, and sustainable value flows. 
              </p>
            </div>
          </li>

          <li className={cx(style.item, "wow", "fadeInRight")}>
            <div className={style.itemIcon}>
              <img src={Icon2} alt="Systems Engineering" />
            </div>
            <div className={style.itemContent}>
              <header className={style.itemHeader}>Systems Engineering</header>
              <p className={style.itemDesc}>
                An interdisciplinary field of engineering and engineering
                management that focuses on how to design and manage complex
                systems using observation and control to create desired
                behaviors.
              </p>
            </div>
          </li>
          <li className={cx(style.item, "wow", "fadeInRight")}>
            <div className={style.itemIcon}>
              <img src={Icon3} alt="Network Science" />
            </div>
            <div className={style.itemContent}>
              <header className={style.itemHeader}>Network Science</header>
              <p className={style.itemDesc}>
                An academic field which studies complex networks such as
                telecommunication networks, computer networks, biological
                networks, cognitive and semantic networks, and social networks.
              </p>
            </div>
          </li>
          <li className={cx(style.item, "wow", "fadeInLeft")}>
            <div className={style.itemIcon}>
              <img src={History} alt="Game Theory" />
            </div>
            <div className={style.itemContent}>
              <header className={style.itemHeader}>Ethnography</header>
              <p className={style.itemDesc}>
              A method to gather qualitative data, observe, and reflect to understand stakeholders’ everyday experiences and apply insights to inform the design, governance, operation, and maintenance of systems.
              </p>
            </div>
          </li>
          <li className={cx(style.item, "wow", "fadeInLeft")}>
            <div className={style.itemIcon}>
              <img src={Icon4} alt="Game Theory" />
            </div>
            <div className={style.itemContent}>
              <header className={style.itemHeader}>Modeling and Simulation</header>
              <p className={style.itemDesc}>
              Computational methods focused on creating digital twins or system representations for analyzing scenarios and projecting and diagnosing system outcomes to inform design and decision-making.
              </p>
            </div>
          </li>
          <li className={cx(style.item, "wow", "fadeInLeft")}>
            <div className={style.itemIcon}>
              <img src={People} alt="AI" />
            </div>
            <div className={style.itemContent}>
              <header className={style.itemHeader}>Artificial Intelligence</header>
              <p className={style.itemDesc}>
              A field that focuses on data processing, estimation, belief formation, and informed decision-making which complements human intelligence by automating cognitively intensive activities, enhancing the efficiency and effectiveness of organizations.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div className={cx(style.successful, "wow rotateIn")} data-wow-offset="200">
      <img
        className={cx(style.substrate, "rotation slower")}
        src={substrate}
        role="presentation"
        alt=""
      />
      <div className={style.successfulContent}>
        <img
          className={style.logo}
          src={hexahedron}
          role="presentation"
          alt=""
        />
        <p>
          Whether automating decision processes, identifying systemic risks in
          company operations, or guiding expansion into a new line of business,
          BlockScience provides thoroughly researched, mathematically
          engineered, human-centric solutions.
        </p>
      </div>
    </div>
  </section>
);
